import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { white } from '@zocdoc-mezzanine/foundations-colors';

/**
 * Overlay
 * Component that renders overlay for a modal.
 * @param {JSX.Element} children - Components to render inside the overlay.
 * @param {function} onClick - Callback which is triggered when overlay is clicked.
 * @param {boolean} whiteOverlay - indicates whether to use white overlay. This will be deprecated soon.
 * This is only used for vaccine related features and will eventually be torn down.
 * @returns {JSX.Element} Overlay
 */
function Overlay({ children, onClick, whiteOverlay }) {
    return (
        <StyledOverlay
            data-test="modal-overlay"
            onClick={onClick}
            whiteOverlay={whiteOverlay}
        >
            {children}
        </StyledOverlay>
    );
}

const StyledOverlay = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 11;

    ${p =>
        p.whiteOverlay &&
        css`
            ${breakpoint('small', { down: true })} {
                background-color: ${white};
                padding-top: 35px;
            }
        `}
`;

export default Overlay;
